/* @flow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dashboard from 'views/dashboard';

export default class ProgramHandler extends Component {
  static propTypes = {
    children: PropTypes.any,
    entities: PropTypes.any,
    txs: PropTypes.any,
    dictionaries: PropTypes.any,
  };

  constructor(): void {
    super();
  }

  render(): React.Element {
    return (this.props.children ?
        React.cloneElement(this.props.children, {
          caseCount: this.props.caseCount,
          caseMissingSamplesCount: this.props.caseMissingSamplesCount,
          caseMissingClinicalCount: this.props.caseMissingClinicalCount,
          sampleCount: this.props.sampleCount,
          portionCount: this.props.portionCount,
          analyteCount: this.props.analyteCount,
          aliquotCount: this.props.aliquotCount,
          aliquotMissingDataCount: this.props.aliquotMissingDataCount,
          readGroupCount: this.props.readGroupCount,
          readGroupMissingFileCount: this.props.readGroupMissingFileCount,
          entities: this.props.entities,
          transactions: this.props.tranactions,
          txs: this.props.txs,
          dictionaries: this.props.dictionaries,
        }) :
        <Dashboard {...this.props} />
    );
  }
}
